import { ThemeOptions } from "@mui/material";

const shape: ThemeOptions["shape"] = { borderRadius: 5 };

export default shape;
